// @ts-nocheck
//TODO: fix the remaining issues
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { markerStyle } from './markerStyle.js';

const Marker = ({ lat, lng, isActive, selectDealer, name, indx, icon }) => {
    const markerRef = useRef();

    if (!lat && !lng) {
        return null;
    }

    const iconUrl = icon && (isActive ? icon.activeUrl || icon.url : icon.url);
    const className = iconUrl
        ? `dealer-page__marker${isActive ? '--active' : ''} dealer-page__marker--pin`
        : `dealer-page__marker${isActive ? '--active' : ''} `;

    return (
        <div className={className} style={markerStyle} onClick={() => selectDealer(name, indx)}>
            {iconUrl &&
                <img className="dealer-page__marker-icon" src={iconUrl} alt="" />}
            {false && isActive &&
                <span>{name}</span>}
        </div>
    );
};

export default React.memo(Marker);
